import React, { ReactNode } from "react";

import clsx from "clsx";

const NumberList = ({ children, className = "list-outside" }: { children?: ReactNode; className?: string }) => (
  <ol className={clsx("list-decimal mb-4 ml-4 space-y-1", className)}>{children}</ol>
);

export default NumberList;
